import { Router } from "@angular/router";
import { EventEmitter, Injectable, Output } from '@angular/core';
import { AppService, CoreProxyService, CoreTypes, SharedCommonService } from 'common-cloudstudio';
import { GearAppService, GearProxyService, GearTypes } from 'common-gear';

import { Subject } from 'rxjs';

@Injectable()
export class SharedService {
  // Dashboard
  onChangeDashboard: Subject<number> = new Subject<number>();
  @Output() public ExecComplete = new EventEmitter<void>();
  _loginTypeSelected: CoreTypes.LoginType;
  _token: string;
  password: string = null;

  constructor(
    private _router: Router,
    private _gearProxyService: GearProxyService,
    public _appService: AppService,
    public _gearService: GearAppService,
    public sharedCommonService: SharedCommonService,
    private _coreProxyService: CoreProxyService
  ) { }

  changeDashboard(id:number){
    this.onChangeDashboard.next(id);
  }

  async goToWithFacilityOrDevice(facility: GearTypes.GearMapFacility, route: string, device?: CoreTypes.DeviceMap) {
    let routeURL = route;
    if(route !== 'reports') {
      this._appService.setFacilityID(facility.FacilityID);
      this._appService.setFacilityDescription(facility.Description);
      this._gearService.externalChangeFacility(facility.FacilityID);
    }

    if (device) {
      if (route === 'dashboard') {
        routeURL = 'dashboard/' + device.Stats.DefaultIDs.Dashboard;
        this._appService.onFacilitySet.next(true);
      }else if (route === 'devices')
        routeURL = await this.getDeviceEndpointsFormsUrl(device.DeviceID);
      else if (route === 'reports')
        routeURL = await this.getDeviceActiveAlarmsReportUrl(device.DeviceID);
      else if (route === 'plans')
        routeURL = 'plans/' + device.Stats.DefaultIDs.View;
    } else {
      if (route === 'dashboard') {
        routeURL = 'dashboard/' + facility.Stats.DefaultIDs.Dashboard;
        this._appService.onFacilitySet.next(true);
      }else if (route === 'devices')
        routeURL = await this.getFacilityDeviceEndpointsFormsUrl(facility.FacilityID);
      else if (route === 'reports')
        routeURL = await this.getFacilityActiveAlarmsReportUrl(facility.FacilityID);
      else if (route === 'plan')
        routeURL = 'plan/' + facility.Stats.DefaultIDs.View;
    }

    // Query Params
    const urlPieces = routeURL.split('?');
    let urlParams = null;

    if (urlPieces[1])
      urlParams = JSON.parse('{"' + decodeURI(urlPieces[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

    this._router.navigate([urlPieces[0]], {queryParams: urlParams}).then(e =>{
      if (!e) {
        setTimeout(() => { this._router.navigate([urlPieces[0]], {queryParams: urlParams}) }, 100);
      }
    });
  }

  getFacilityActiveAlarmsReportUrl(facilityID: number):Promise<string> {
    return new Promise((resolve, reject) => {
      this._coreProxyService.ReportingService.GetFacilityActiveAlarmsReportUrl(
        this._appService.getAccessToken(),
        facilityID,
        data => {
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    })
  }

  getFacilityDeviceEndpointsFormsUrl(facilityID: number):Promise<string> {
    return new Promise((resolve, reject) => {
      this._coreProxyService.ReportingService.GetFacilityDeviceEndpointsFormsUrl(
        this._appService.getAccessToken(),
        facilityID,
        data => {
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    })
  }

  getDeviceActiveAlarmsReportUrl(deviceID: number):Promise<string> {
    return new Promise((resolve, reject) => {
      this._coreProxyService.ReportingService.GetDeviceActiveAlarmsReportUrl(
        this._appService.getAccessToken(),
        deviceID,
        data => {
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    })
  }

  getDeviceEndpointsFormsUrl(deviceID: number):Promise<string> {
    return new Promise((resolve, reject) => {
      this._coreProxyService.ReportingService.GetDeviceEndpointsFormsUrl(
        this._appService.getAccessToken(),
        deviceID,
        data => {
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    })
  }

  execAction(id, actionType, currentValue, previusValue?) {
    this._appService.startLoading();
    let parameters: GearTypes.GearDisplayClusterActionParameters = new GearTypes.GearDisplayClusterActionParameters();
    parameters.Value = currentValue;
    this._gearProxyService.RealTimeDataService.ExecuteAction2(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      id,
      parameters,
      new CoreTypes.LoginRequest(),
      () => {
        // Emitir evento para informar la ejecucion exitosa.
        this.ExecComplete.next();
        this._appService.stopLoading();
        this.sharedCommonService.onConfirmOperationChangeValue.next(true);
      },
      (error) => {
        this.sharedCommonService.onConfirmOperationChangeValue.next(false);
        this._appService.stopLoading();
        this._appService.showException(error);
      }
    );
  }
}
